function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef, useCallback } from 'react';
import InputField from './InputField';
export default function SelectInput(_ref) {
  var wrapperClasses = _ref.wrapperClasses,
    label = _ref.label,
    parseLabel = _ref.parseLabel,
    help = _ref.help,
    identifier = _ref.identifier,
    options = _ref.options,
    currentOption = _ref.currentOption,
    setCurrentOption = _ref.setCurrentOption,
    icon = _ref.icon,
    toggledIcon = _ref.toggledIcon,
    disabled = _ref.disabled;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    toggled = _useState2[0],
    _setToggled = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    currentSelectedIndex = _useState4[0],
    _setCurrentSelectedIndex = _useState4[1];
  var didMountRef = useRef(false);
  var currentSelectedIndexRef = useRef(currentSelectedIndex);
  var toggledRef = useRef(toggled);
  var selectIdentifier = identifier || 'value';
  var current = options.find(function (option) {
    return option[selectIdentifier] === currentOption;
  });
  useEffect(function () {
    if (didMountRef.current) {
      if (toggledRef.current) {
        document.addEventListener('keydown', handleKeyDown, true);
        document.addEventListener('click', closeMenuWithEvent, true);
        setCurrentSelectedIndex(0);
      }
    } else {
      didMountRef.current = true;
    }
  }, [toggled]);
  function setToggled(state) {
    _setToggled(state);
    toggledRef.current = state;
  }
  function setCurrentSelectedIndex(state) {
    _setCurrentSelectedIndex(state);
    currentSelectedIndexRef.current = state;
  }
  function closeMenu() {
    document.removeEventListener('keydown', handleKeyDown, true);
    document.removeEventListener('click', closeMenuWithEvent, true);
    setToggled(false);
    setCurrentSelectedIndex(null);
  }
  var closeMenuWithEvent = useCallback(function (event) {
    if (event && !event.target.classList.contains('select-option')) {
      if (!event.target.classList.contains('input-wrapper')) {
        document.removeEventListener('keydown', handleKeyDown, true);
        document.removeEventListener('click', closeMenuWithEvent, true);
      }
      setToggled(false);
      setCurrentSelectedIndex(null);
    }
  }, [toggledRef.current]);
  var handleKeyDown = useCallback(function (event) {
    if (toggledRef.current) {
      if (event.key === 'Escape') {
        closeMenu();
      } else if (event.key === 'Enter') {
        if (currentSelectedIndexRef.current !== null) {
          selectOption(options[currentSelectedIndexRef.current]);
        }
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
        var index = null;
        if (options.length) {
          if (event.key === 'ArrowUp') {
            if (currentSelectedIndexRef.current !== null && currentSelectedIndexRef.current > 0) {
              index = currentSelectedIndexRef.current - 1;
            } else {
              index = options.length - 1;
            }
          } else if (event.key === 'ArrowDown') {
            if (currentSelectedIndexRef.current !== null && currentSelectedIndexRef.current < options.length - 1) {
              index = currentSelectedIndexRef.current + 1;
            } else {
              index = 0;
            }
          }
        }
        if (index !== null) {
          setCurrentSelectedIndex(index);
        }
      }
    }
  }, [toggledRef.current]);
  function selectOption(option) {
    if (option.onSelect) {
      option.onSelect(option);
    } else {
      setCurrentOption(option);
    }
    closeMenu();
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "select-input"
  }, /*#__PURE__*/React.createElement(InputField, {
    classes: wrapperClasses,
    label: label,
    parseLabel: parseLabel,
    help: help
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-wrapper",
    onClick: function onClick() {
      return setToggled(!toggled);
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: currentSelectedIndex ? options[currentSelectedIndex].title : current ? current.title : '',
    disabled: disabled,
    onChange: function onChange() {}
  }), !disabled && /*#__PURE__*/React.createElement("div", {
    className: "input-icon"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa-light ".concat(toggled ? toggledIcon || 'fa-chevron-up' : icon || 'fa-chevron-down')
  })), toggled && !disabled && /*#__PURE__*/React.createElement("div", {
    className: "select-options-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "select-options"
  }, options.map(function (option, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(option.value, "_").concat(index),
      className: "select-option ".concat(currentSelectedIndex === index ? 'selected' : ''),
      onMouseEnter: function onMouseEnter() {
        return setCurrentSelectedIndex(index);
      },
      onClick: function onClick() {
        return selectOption(option);
      }
    }, option.itemRenderer ? option.itemRenderer(option) : option.title);
  }))))));
}